import React, { useState } from "react";

import {
  Row,
  Col,
  Card,
  Typography,
  Avatar,
  Space,
  Table,
  Tag,
  Progress,
  Button,
  Badge,
  Dropdown,
} from "antd";

import {
  UserOutlined,
  BookOutlined,
  DollarOutlined,
  CalendarOutlined,
  RiseOutlined,
  TrophyOutlined,
  PlusOutlined,
  DownOutlined,
} from "@ant-design/icons";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { motion } from "framer-motion";

import SelectAcademyYear from "../AcademyYearSelection/SelectAcademyYear";
import AddClass from "../../pages/Students/AddClass";
import SubjectFormModal from "../../SchoolDashApp/Class/Subjects/SubjectFormModal";
import DivisionFormModal from "../../SchoolDashApp/Division/DivisionFormModal";
import TotalStudentsCard from "./TotalStudentsCard";
// import YearlySchoolFeeCount from "./YearlySchoolFeeCount"
import TodoList from "../CalenderAndTodo/TodoList";
import CalendarViewAndTransaction from "../CalenderAndTodo/CalendarViewAndTransaction";
import DailyPaymentTransaction from "./DailyPaymentTransaction";
import AcademicCount from "./AcademicCount";
import EmployeeCount from "./EmployeeCount";



const { Title, Text } = Typography;

const OverviewRegister = ({ theme }) => {
  const [openAddClass, setOpenAddClass] = useState(false);
  const [openSubjectModal, setOpenSubjectModal] = useState(false);
  const [openDivisionModal, setOpenDivisionModal] = useState(false);

  // Dashboard Statistics
  const stats = [
    {
      title: "Teachers",
      value: "145",
      icon: <UserOutlined />,
      color: "#7A1F2B",
    },
    {
      title: "Classes",
      value: "68",
      icon: <BookOutlined />,
      color: "#D4AF37",
    },

  ];

  // Add Dropdown Menu
  const addMenu = {
    items: [
      {
        key: "class",
        label: "Add Class",
        icon: <PlusOutlined />,
      },
      {
        key: "subject",
        label: "Add Subject",
        icon: <PlusOutlined />,
      },
      {
        key: "division",
        label: "Add Division",
        icon: <PlusOutlined />,
      },
    ],

    onClick: ({ key }) => {
      switch (key) {
        case "class":
          setOpenAddClass(true);
          break;

        case "subject":
          setOpenSubjectModal(true);
          break;

        case "division":
          setOpenDivisionModal(true);
          break;

        default:
          break;
      }
    },
  };



  return (
        <div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            gap: 16,
            flexWrap: "wrap",
          }}
          className="dashboard-header"
        >
          <SelectAcademyYear theme={theme} />

          <Dropdown
            menu={addMenu}
            placement="bottomRight"
            trigger={["click"]}
          >
            <Button
              type="primary"
              size="large"
              icon={<PlusOutlined />}
            >
              Add <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      </div>

      <br />

      {/* Total Students Card */}

<Row
  gutter={[12, 12]}
  justify="center"
  style={{
    width: "100%",
  }}
>
    <Col xs={24} sm={12} lg={6}>
        <TotalStudentsCard theme={theme} />
    </Col>


    <Col xs={24} sm={12} lg={6}>
      <AcademicCount theme={theme} /> 
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <EmployeeCount theme={theme} /> 
    </Col>
    
</Row>

      <br />

      {/* <Row>
        <DailyPaymentTransaction />
      </Row> */}

      {/* Other Dashboard Statistics */}
 

      <Row
        gutter={[12, 12]}
        style={{ marginTop: 12 }}
      >
        <Col
          xs={24}
          lg={12}
        >
          <Card>
            <div>
              <TodoList />
            </div>
          </Card>
        </Col>

        <Col
          xs={24}
          lg={12}
        >
          <Card>
            <div>
              <CalendarViewAndTransaction />
            </div>
          </Card>
        </Col>
      </Row> 
          

      {/* Modals */}
      <div>
        <AddClass
          open={openAddClass}
          handleClose={() => setOpenAddClass(false)}
        />

        <SubjectFormModal
          open={openSubjectModal}
          handleClose={() => setOpenSubjectModal(false)}
          onSubjectCreated={() => {
            console.log("Refresh subjects list here");
          }}
        />

        <DivisionFormModal
          open={openDivisionModal}
          handleClose={() => setOpenDivisionModal(false)}
          onDivisionCreated={() => {
            // Refresh your division list here
          }}
        />
      </div>
    </div>
  );
};

export default OverviewRegister;